<template>
  <svg xmlns="http://www.w3.org/2000/svg" :height="size + 'px'" viewBox="0 -960 960 960" :width="size + 'px'" fill="currentColor">
    <path d="m216-160-56-56 464-464H360v-80h400v400h-80v-264L216-160Z"/>
  </svg>
</template>

<script>
import IconBase from "@/mixins/Icon/IconBase";

export default {
  name: "IconArrowNortheast",
  mixins: [ IconBase ],
  props: { ...IconBase.props }
}
</script>